import { extend, localize } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

// Install required rule.
extend("required", {
    ...required,
    message: 'Este campo é obrigatório'
});

// Install email rule.
extend("email", {
    ...email,
    message: 'O email informado é inválido'
});

extend('password', {
    params: ['target'],
    validate(value, {target}) {
        return value === target
    },
    message: 'As senhas não conferem!'
});


// Install min rule.
extend("min", min);